"use client";

import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";
import {
  addToWishlist,
  removeFromWishlist,
  isInWishlist,
} from "@/lib/wishlist-manager";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";

export default function AddToWishlistButton({ product }) {
  const t = useTranslations("wishlist");
  const [inWishlist, setInWishlist] = useState(false);

  useEffect(() => {
    setInWishlist(isInWishlist(product.id_product));
  }, [product.id_product]);

  const handleToggleWishlist = () => {
    if (inWishlist) {
      removeFromWishlist(product.id_product);
      setInWishlist(false);
    } else {
      addToWishlist(product);
      setInWishlist(true);
    }
  };

  return (
    <Button
      onClick={handleToggleWishlist}
      variant="outline"
      className="gap-2.5 bg-background"
    >
      <Heart
        className={cn(
          inWishlist
            ? "fill-current text-red-500"
            : "fill-current text-gray-500",
          " size-4",
        )}
      />
      {inWishlist ? t("remove") : t("add")}
    </Button>
  );
}
